import { isRunStateInProgress, normalizeRunStateValue } from '@/lib/pieveRunState.js';

const shouldPreserveExistingRunStateDuringHydration = ({ existingRunState, incomingRunState }) => {
  if (!isRunStateInProgress(existingRunState?.state)) {
    return false;
  }

  const incomingState = normalizeRunStateValue(incomingRunState?.state);
  const incomingRunId = String(incomingRunState?.runId || '').trim();

  if (incomingState !== 'idle') {
    return false;
  }

  if (incomingRunId) {
    return false;
  }

  return true;
};

export default shouldPreserveExistingRunStateDuringHydration;
